import OriginModal, { ModalFuncProps } from "antd/lib/modal";
import {
  modalGlobalConfig,
  ModalStaticFunctions,
} from "antd/lib/modal/confirm";
import useModal from "antd/lib/modal/useModal";
import GenericModal, { GenericModalProps, onOpenModal } from "./GenericModal";

type ConfigUpdate =
  | ModalFuncProps
  | ((prevConfig: ModalFuncProps) => ModalFuncProps);

type ExtendedModalFunc = (props: GenericModalProps) => {
  destroy: () => void;
  update: (configUpdate: ConfigUpdate) => void;
};

type ExtendedModalStaticFunction = ModalStaticFunctions & {
  openModal: ExtendedModalFunc;
};

type ModalType = typeof OriginModal &
  ExtendedModalStaticFunction & {
    useModal: typeof useModal;
    destroyAll: () => void;
    config: typeof modalGlobalConfig;
  };

export const Modal = OriginModal as ModalType;

Modal.useModal = useModal;

Modal.openModal = function openModalFn(props: GenericModalProps) {
  return GenericModal(onOpenModal(props));
};

Modal.config = modalGlobalConfig;

export default Modal;
